<nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (tab of tabs; track tab.id) {
        @if (tab.subTabs; as subTabs) {
            <button mat-tab-link [matMenuTriggerFor]="subTabMenu"
                    #trigger="matMenuTrigger"
                    [active]="selectedIndex() == $index"
                    [matTooltip]="subTabs[selectedSubIndex()].translationKey | translate"
                    [matTooltipDisabled]="!layoutService.isSmallScreen()">
                <span class="title" #button>
                    <mat-icon class="symbol"> {{ subTabs[selectedSubIndex()].icon }}</mat-icon>
                    <span *breakpoints="[ScreenSize.LARGE, ScreenSize.MEDIUM]">
                        {{ subTabs[selectedSubIndex()].translationKey | translate }}
                    </span>
                    <mat-icon>
                        @if (trigger.menuOpen) {
                            keyboard_arrow_up
                        } @else {
                            keyboard_arrow_down
                        }
                    </mat-icon>
                    <mat-menu #subTabMenu="matMenu" xPosition="before">
                        @for (subTab of subTabs; track subTab.id) {
                            <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
                            <a mat-menu-item [routerLink]="[subTab.id]"
                               [style.min-width.px]="button.getBoundingClientRect().width + 16">
                                <mat-icon class="symbol"> {{ subTab.icon }}</mat-icon>
                                <span>
                                    {{ subTab.translationKey | translate }}
                                </span>
                            </a>
                        }
                    </mat-menu>
                </span>
            </button>
        } @else {
            <a mat-tab-link
               [routerLink]="[tab.id]"
               [active]="selectedIndex() == $index"
               [matTooltip]="tab.translationKey ? (tab.translationKey | translate) : tab.label"
               [matTooltipDisabled]="!layoutService.isSmallScreen()">
                <span class="title">
                    <mat-icon class="symbol"> {{ tab.icon }}</mat-icon>
                    <span *breakpoints="[ScreenSize.LARGE, ScreenSize.MEDIUM]">
                        @if (tab.translationKey) {
                            {{ tab.translationKey | translate }}
                        } @else {
                            {{ tab.label }}
                        }
                    </span>
                </span>
            </a>
        }
    }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>